import React, { useRef, useEffect } from 'react';
import { FilterChip } from './FilterChip';

interface ChipListProps {
    list?: string[];
    selectionIndex?: number | null;
    onRemove?: (index: number) => void;
}

export function ChipList({ list = [], selectionIndex = null, onRemove }: ChipListProps) {
    const refList = useRef<HTMLDivElement>(null);
    const refChildren = useRef<HTMLDivElement[]>([]);
    const refListLength = useRef(0);

    // Scroll the selected chip into view by summing widths of all chips up to selectionIndex.
    useEffect(() => {
        if (selectionIndex !== null && refChildren.current[selectionIndex] && refList.current) {
            let offset = 0;

            for (let i = 0; i <= selectionIndex; i++) {
                offset += refChildren.current[i].offsetWidth;
            }
            refList.current.scrollLeft = offset - refList.current.clientWidth + 15;
        }
    }, [selectionIndex]);

    // Auto-scroll to the end when a new chip is added so the latest chip is always visible.
    useEffect(() => {
        if (refList.current && refListLength.current < list.length) {
            refList.current.scrollLeft = refList.current.scrollWidth;
            refListLength.current = list.length;
        } else {
            refListLength.current = list.length;
        }
    }, [list]);

    refChildren.current = [];

    return (
        <div ref={refList} className="chip-list">
            {list.map((item, i) => (
                <FilterChip
                    key={i}
                    ref={(node: HTMLDivElement) => { refChildren.current[i] = node; }}
                    selected={selectionIndex === i}
                    text={item}
                    onRemove={() => onRemove?.(i)}
                />
            ))}
        </div>
    );
}
